import React from 'react'
import A from '../../A'

import styles from './Socials.module.scss'

const ExpandTop = ({
  open,
  blurStart,
  blurEnds,
  socials,
  txt,
  width
}) => (<div className={styles.container} style={{width, }}>
  <div className={styles.overlay + (open ? ' ' + styles.open : '')}>
  {
    socials.map((e,i) => (
      <div key={'social-' + i}>
        <A
          href={e.url}
          className={styles.item}
        >
          {e.text}
        </A>
      </div>
      )
    )
  }
  </div>
  <div
    className={styles.social}
    onClick={blurStart}
  >
      <A style={{
        fontWeight: open ? 'bold':'',
        fontSize: '12px',
        lineHeight: '18px',
        color: '#222222'
      }}>{txt}</A>
  </div>
</div>)

export default ExpandTop
